// Shared request status pipeline for admin request management
export const REQUEST_STATUSES = [
  { value: "neu", label: "Neue Anfrage", cls: "bg-[#EEF3FF] text-[#2B4A9B] border-[#B9CBF0]" },
  { value: "kontaktiert", label: "Kunde kontaktiert", cls: "bg-[#F3ECFF] text-[#632A8E] border-[#D8C2F0]" },
  { value: "in_verhandlung", label: "In Verhandlung", cls: "bg-[#FFF4D6] text-[#8A5A00] border-[#F0D48A]" },
  { value: "kauf_zugesagt", label: "Kunde will kaufen", cls: "bg-[#E7F0FF] text-[#1E5F9B] border-[#B5D2F0]" },
  { value: "verkauft", label: "Verkauft / Abgeschlossen", cls: "bg-[#E9F7EC] text-[#1E7A3A] border-[#B5E2C1]" },
  { value: "kein_interesse", label: "Kein Interesse mehr", cls: "bg-[#F3F0F0] text-[#7A6E6E] border-[#DCD3D3]" },
  { value: "archiviert", label: "Archiviert", cls: "bg-[#ECECEC] text-[#555555] border-[#CFCFCF]" },
];

export const statusInfo = (v) => REQUEST_STATUSES.find((s) => s.value === v) || REQUEST_STATUSES[0];

// Gentle, customer-facing mapping (shown in "Mein Konto")
export const CUSTOMER_STATUS = {
  neu: { label: "Eingegangen", cls: "bg-[#EEF3FF] text-[#2B4A9B] border-[#B9CBF0]" },
  kontaktiert: { label: "In Bearbeitung", cls: "bg-[#FFF4D6] text-[#8A5A00] border-[#F0D48A]" },
  in_verhandlung: { label: "In Bearbeitung", cls: "bg-[#FFF4D6] text-[#8A5A00] border-[#F0D48A]" },
  kauf_zugesagt: { label: "In Bearbeitung", cls: "bg-[#FFF4D6] text-[#8A5A00] border-[#F0D48A]" },
  verkauft: { label: "Abgeschlossen", cls: "bg-[#E9F7EC] text-[#1E7A3A] border-[#B5E2C1]" },
  kein_interesse: { label: "Abgeschlossen", cls: "bg-[#F3F0F0] text-[#7A6E6E] border-[#DCD3D3]" },
  archiviert: { label: "Abgeschlossen", cls: "bg-[#F3F0F0] text-[#7A6E6E] border-[#DCD3D3]" },
};
export const customerStatus = (v) => CUSTOMER_STATUS[v] || CUSTOMER_STATUS.neu;
